<template>
  <div>
    <v-dialog
      max-width="350px"
      max-height="350px"
      v-model="show"
      scrollable
    >
      <v-card>
        <v-card-title>
          Compensation Type
          <v-spacer></v-spacer>
          <v-btn
            icon
            @click.prevent="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-3">
          <v-row justify="center">
            <v-col cols="12" md="12" lg="12">
              <h3>Compensation Name</h3>
              <v-text-field
                v-model="currentCompensationType.Compensation_Name"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small color="primary" @click.prevent="saveCompensationType" :disabled="saveCompensationTypeDisable">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>

export default {
  name: 'TechnologyEditor',
  props: {
    value: {
      required: false
    },
    currentCompensationType: {
      required: false,
      default: null
    },
    addMode: {
      required: false,
      default: false
    }
  },
  data () {
    return {
      saveCompensationTypeDisable: false
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    user () {
      return this.$store.getters.getUser
    }
  },
  mounted () {
  },
  methods: {
    saveCompensationType () {
      this.saveCompensationTypeDisable = true
      if (this.addMode) {
        const body = {
          Compensation_Name: this.currentCompensationType.Compensation_Name
        }
        this.axios.post('/api/payroll/compensation_type', body, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveCompensationTypeDisable = false
          this.$store.dispatch('setSuccess', { successMsg: 'Compensation Type succesefully added' })
          this.show = false
        }).catch(error => {
          this.saveCompensationTypeDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      } else {
        this.axios.put(`/api/payroll/compensation_type/${this.currentCompensationType.Compensation_Type_ID}`, this.currentCompensationType, {
          headers: {
            Authorization: 'Bearer ' + this.user.token
          }
        }).then(res => {
          this.saveCompensationTypeDisable = false
          this.$store.dispatch('setSuccess', { successMsg: 'Compensation Type succesefully updated' })
          this.show = false
        }).catch(error => {
          this.saveCompensationTypeDisable = false
          this.$store.dispatch('setError', { errorMsg: error.message + ' - ' + error.response.data })
        })
      }
    }
  }
}
</script>
